<div class="informate_select_wrapper" [formGroup]="form">
    <mat-label class="mat-label-general" [ngbTooltip]="jointType2_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Joint Type -->
        {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.JOINT_TYPE' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #jointType2_tooltip>
        <p>
            For each flange size there are often a number of different types of flange available, they are selected based on the specific requirements of the
            connection, the most common Joint Type is the Weld Neck but there are many others with other uses for example: blind fianges are used to act as an
            end point of a line, slip-on and swivel ring flanges are used where there may be radial misalignment between the bolt holes.
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select formControlName="flangeType2" name="joint_type" class="mat-select-general input-form-class" [class.spinner]="loading">
        <mat-option class="option-list" *ngFor="let ftl of flangeTypeList" [value]="ftl.flangeTypeId">{{ ftl.flangeTypeName }}</mat-option>
    </mat-select>
</div>
